import { PromotionDeal } from '../types/Deals';
import { DealCard } from './DealCard';

type DealsListProps = {
  deals: PromotionDeal[];
};

export const DealsList = ({ deals }: DealsListProps) => {
  if (!deals.length) {
    return null;
  }

  return (
    <div className="flex flex-col space-y-2 py-2">
      {deals.map(item => (
        <DealCard key={item.id} deal={item} />
      ))}
    </div>
  );
};
